// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__N_U_t","left":"Button_left__KR7EK","Success":"Button_Success__1gm3_","Danger":"Button_Danger__37TTE"};